import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import ClientSideComponent from "../../../ClientSideComponent.js";
const CallCenter = /*#__PURE__*/ lazy(()=>import("./CallCenter.js"));
const LazyCallCenter = ()=>/*#__PURE__*/ jsx(ClientSideComponent, {
        children: /*#__PURE__*/ jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ jsx(CallCenter, {})
        })
    });
const CallCenter_LazyCallCenter = LazyCallCenter;
export default CallCenter_LazyCallCenter;
